export interface Credit {
  id: number;
  title: string;
  year: string;
  role: string;
  type: 'Film' | 'TV Series' | 'Short' | 'TV Movie';
  episodes?: string;
  status?: string;
  notes?: string;
}

export const actorCredits: Credit[] = [
  {
    id: 16,
    title: 'The Truffaut Affair',
    year: '2026',
    role: 'The Director',
    type: 'Film',
  },
  {
    id: 34,
    title: 'Wrong for Right',
    year: '2026',
    role: 'Chris Damon',
    type: 'Film',
  },
  {
    id: 17,
    title: 'Dream Baby Dream',
    year: '2025',
    role: 'Fariz',
    type: 'Film',
  },
  {
    id: 18,
    title: 'The Goose That Laid the Golden Eggs',
    year: '2025',
    role: 'Professeur Pierre Martin',
    type: 'Film',
  },
  {
    id: 19,
    title: 'My Double Life as the CEO\'s Wife',
    year: '2025',
    role: 'Atkins',
    type: 'Film',
  },
  {
    id: 20,
    title: 'Balthazar and Friar John',
    year: '2025',
    role: 'Omelette de fromage',
    type: 'Film',
  },
  {
    id: 21,
    title: 'Merily',
    year: '2024',
    role: 'Co-worker',
    type: 'Film',
  },
  {
    id: 1,
    title: 'Little Miss Sociopath',
    year: '2024',
    role: 'Robert Marlow',
    type: 'Film',
    notes: 'Killer Television',
  },
  {
    id: 2,
    title: 'Foolproof',
    year: '2024',
    role: 'Chase',
    type: 'TV Series',
    episodes: '7 episodes',
  },
  {
    id: 22,
    title: 'Quinn',
    year: '2023',
    role: 'Kidnapper',
    type: 'Film',
  },
  {
    id: 5,
    title: 'Deadly Secrets of a Cam Girl',
    year: '2023',
    role: 'Big Daddy',
    type: 'TV Movie',
    notes: 'Lifetime',
  },
  {
    id: 6,
    title: 'The Devil\'s Fortune',
    year: '2023',
    role: 'Rukan',
    type: 'Film',
  },
  {
    id: 7,
    title: 'Red Carpet',
    year: '2021',
    role: 'Cartel',
    type: 'Short',
  },
  {
    id: 24,
    title: 'Silver Age',
    year: '2020',
    role: 'Inky',
    type: 'Film',
  },
  {
    id: 25,
    title: 'Khalifornia',
    year: '2020',
    role: 'Spaniard Two',
    type: 'Film',
  },
  {
    id: 12,
    title: 'Huge in France',
    year: '2019',
    role: 'Michel / The Bellman',
    type: 'Film',
  },
  {
    id: 13,
    title: 'Secret in Provence',
    year: '2019',
    role: 'M.J.',
    type: 'Short',
  },
  {
    id: 23,
    title: 'Trouble is My Business',
    year: '2018',
    role: 'Museum Guard',
    type: 'Film',
  },
  {
    id: 15,
    title: 'Garden Variety Spider: Chapter One',
    year: '2018',
    role: 'Manny',
    type: 'Short',
  },
  {
    id: 26,
    title: 'Vermin Town',
    year: '2017',
    role: 'Clerk',
    type: 'Film',
  },
  {
    id: 27,
    title: 'When it Rains',
    year: '2017',
    role: 'Steve',
    type: 'Film',
  },
  {
    id: 28,
    title: 'Tail',
    year: '2017',
    role: 'Detective',
    type: 'Film',
  },
  {
    id: 29,
    title: 'Scandal',
    year: '2017',
    role: 'Bartender',
    type: 'Film',
  },
  {
    id: 30,
    title: 'Le Père',
    year: '2017',
    role: 'Claude',
    type: 'Film',
  },
  {
    id: 31,
    title: 'Clockwork',
    year: '2017',
    role: 'Prison Guard',
    type: 'Film',
  },
  {
    id: 32,
    title: 'Simple Lives',
    year: '2016',
    role: 'Detective Holt',
    type: 'Film',
  },
  {
    id: 33,
    title: 'Freakish',
    year: '2016',
    role: 'Freak',
    type: 'Film',
  },
];

export const producerCredits: Credit[] = [
  {
    id: 101,
    title: 'Foolproof',
    year: '2023',
    role: 'Producer',
    type: 'TV Series',
  },
];

export const writerCredits: Credit[] = [
  {
    id: 201,
    title: 'Foolproof',
    year: '2023',
    role: 'Writer',
    type: 'TV Series',
  },
];

export const filmographyStats = {
  totalCredits: 15,
  filmCredits: 2,
  tvCredits: 4,
  shortCredits: 9,
  yearsActive: '2016 - Present',
  affiliation: 'SAG-AFTRA',
};
